export const RESUBMIT_STEPS = {
  INIT: 'INIT',
  REASON: 'REASON',
  RESUBMIT: 'RESUBMIT',
  OVERVIEW: 'OVERVIEW'
};
